import { FormControl, FormGroup, Validators } from '@angular/forms'
import { NewsletterType } from '@pai/commons'

import { modifyControlStatus } from 'app/utils/forms/modify-control-enabled.function'
import { PaiValidators } from 'app/utils/forms/pai-validators'
import { FormGroupValueTypeHelper } from 'app/utils/types/form-group-type-helper.type'

const controls = () => ({
  type: new FormControl<NewsletterType>(NewsletterType.PAPER, { nonNullable: true }),

  givenName: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(2), Validators.maxLength(50)]),
  familyName: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(2), Validators.maxLength(50)]),

  address: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(2), Validators.maxLength(50)]),
  postalCode: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(2), Validators.maxLength(50)]),
  city: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(2), Validators.maxLength(50)]),
  country: new FormControl('CH', [PaiValidators.requiredString]),

  email: new FormControl(null, [PaiValidators.requiredString, PaiValidators.email]),

  comment: new FormControl(null),
})

export class NewsletterSubscriptionForm extends FormGroup<ReturnType<typeof controls>> {
  declare value: FormGroupValueTypeHelper<ReturnType<typeof controls>>

  constructor() {
    super(controls())
  }

  override updateValueAndValidity(...args: Parameters<FormGroup['updateValueAndValidity']>) {
    const { type, address, postalCode, city, country, email } = this.controls

    const paper = type.value === NewsletterType.PAPER

    modifyControlStatus(address, paper)
    modifyControlStatus(postalCode, paper)
    modifyControlStatus(city, paper)
    modifyControlStatus(country, paper)

    modifyControlStatus(email, !paper)

    super.updateValueAndValidity(...args)
  }
}
